import upperFirst from "lodash/upperFirst";

// 支持 三级目录， 多于三级不支持

let layouts = require
  .context("@/layouts", false, /\.vue$/i)
  .keys()
  .map((item) => {
    const paths = item.split(".")[1].match(/[a-zA-Z0-9]+/g);
    return {
      name: paths[0],
      path: item.slice(1),
    };
  });
const files = require.context("@/views", true, /^((?!components).)*\.vue$/i)
let routers = files.keys();
let indexRouterMap = {};
let detailRouterArr = [{
  path: '',
  redirect:'/mine'
}];
routers.forEach((item) => {
  const name = files(item).default.name
  const paths = item.split(".")[1].match(/[a-zA-Z0-9]+/g);
  const routerChild = {
    path: paths[1] === "index" ? "" : paths[1],
    name: name || `${paths[0]}${upperFirst(paths[1])}`,
    meta: files(item).default.meta || {},
    component(resolve) {
      require([`@/views${item.slice(1)}`], resolve);
    },
  };
  if (/index\.vue$/.test(item)) {
    if (indexRouterMap[paths[0]]) {
      indexRouterMap[paths[0]].children.push(routerChild);
    } else {
      const layout = layouts.find((e) => e.name === paths[0]) || {};
      indexRouterMap[paths[0]] = {
        path: "/" + paths[0],
        component(resolve) {
          if (layout.path) {
            require([`@/layouts${layout.path}`], resolve);
          } else {
            require(["@/layouts/default.vue"], resolve);
          }
        },
        children: [routerChild],
      };
    }
  } else {
    detailRouterArr.push({
      path: item.slice(1, -4),
      name: `${paths[0]}${upperFirst(paths[1])}${upperFirst(paths[2])}`,
      component(resolve) {
        require([`@/views${item.slice(1)}`], resolve);
      },
    });
  }
});
export default [...Object.values(indexRouterMap), ...detailRouterArr];
